export default __webpack_public_path__ + "static/media/aakash-anthe-logo.81aa0499.png";